import { useContext } from 'react';
import { AppContext } from '../../contexts/context';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import Zoom from '@mui/material/Zoom';
import { useTheme } from '@mui/styles';
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';

export const AppOpenCard = () => {
  const [ state, dispatch ] = useContext(AppContext);
  const theme = useTheme()

  const handleDismissClick = () => {
    dispatch({type: 'app/ui/card/appOpen', value: 'dismissed'});
  }

  const handleOpenApp = () => {
    window.open(state.currentURL, '_blank');
  }

  return (
    <Zoom in={true} style={{ transitionDelay: '500ms'}}>
      <Card sx={{
          border: '1px solid',
          borderColor: theme.palette.primary.main,
          borderRadius: 5,
          display: "flex",
          flexDirection: "column",
          paddingX: 2,
          boxShadow: "none",
          alignItems: "left",
          justifyContent: "left"
        }}>
        <CardHeader
            avatar={
              <Avatar sx={{ bgcolor: "#fff", padding:0.9 }} aria-label="status_icon">
                <DownloadDoneIcon color={"primary"} sx={{fontSize:50, color: theme.palette.primary.main}}/>
              </Avatar>
            }
            title="Information"
            subheader={"App is installed"}
            titleTypographyProps={{marginLeft:0, color:"text.primary", variant:"h6", fontWeight: 'normal'}}
        />
        <CardContent sx={{mt:0, pt:0, pb:0}}>
          <Typography variant="body2" color="text.secondary">
            The app was installed successfully. Switch from the browser view to the app if you like.
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            color="primary"
            onClick={handleOpenApp}
          >
            Open App
          </Button>
          <Button
            color="primary"
            onClick={handleDismissClick}
          >
            Dismiss
          </Button>
        </CardActions>
      </Card>
    </Zoom>
  )
}

export default AppOpenCard;
